<template>
  <div class="personal bg-weight">
    <loading v-if="busy" style="background: #fff;margin-top: 100px;"></loading>
    <div v-else>
      <div class="small-title" :class="isShowTop !== 1 ? 'small-persion-title': ''">
        <i></i>
        <span>个人信息</span>
      </div>
      <div>
        <div class="item name">
          <div class="left">
            <span class="text">
              <span>*</span> 真实姓名：
            </span>
          </div>
          <div class="input1" v-if="!auth">
            <p class="errorMsg">{{errorMsg.realName}}</p>
            <input @blur="checkInput('name')" type="text" v-model="user.realName">
            <i class="iconfont icon-close" v-if="user.realName" @click="clear($event,'realName')"></i>
          </div>
          <div class="input1" v-else>{{user.realName || '暂无'}}</div>
        </div>
        <div class="item phone">
          <div class="left">
            <span class="text">
              <span>*</span> 手机号：
            </span>
          </div>
          <div class="input1" v-if="!auth">
            <p class="errorMsg">{{errorMsg.phone}}</p>
            <input @blur="checkInput('phone')" type="number" v-model="user.phone">
            <i class="iconfont icon-close" v-if="user.phone" @click="clear($event,'phone')"></i>
          </div>
          <div class="input1" v-else>{{user.phone || '暂无'}}</div>
          <div class="code" v-if="!auth">
            <div class="input1">
              <p class="errorMsg">{{errorMsg.code}}</p>
              <input
                @blur="checkInput('code', false)"
                type="number"
                v-model="user.code"
                placeholder="请输入验证码"
              >
              <span class="disableSpan" v-if="timer > 0">{{timer}}s后发送</span>
              <span v-else @click="getCode">点击发送</span>
            </div>
          </div>
        </div>
        <div class="item phone">
          <div class="left">
            <span class="text">
              <span>*</span> 地址：
            </span>
          </div>
          <div class="input2" id="input2" v-if="!auth || !detailData.status">
            <p class="errorMsg">{{errorMsg.detailAddress}}</p>
            <div class="city" id="city" style="width: 154px;">
              <span class="label" style="margin-left:0px;">省份：</span>
              <Select name="province" @on-change="changeProvince" v-model="provinceId">
                <Option :value="p.id" :key="p.id" v-for="p in addressData">{{p.name}}</Option>
              </Select>
            </div>

            <div class="city" id="city">
              <span class="label" style="margin-left:20px;">城市：</span>
              <Select name="city" @on-change="changeCity" v-model="cityId">
                <Option :value="c.id" :key="c.id" v-for="c in cityData">{{c.name}}</Option>
              </Select>
            </div>

            <div class="city" id="cityCC">
              <span class="label" style="margin-left:20px;">区/县：</span>
              <Select name="city" @on-change="changeArea" v-model="user.locationId">
                <Option :value="c.id" :key="c.id" v-for="c in areaData">{{c.name}}</Option>
              </Select>
            </div>
          </div>
          <div
            class="input2"
            v-else
            style="line-height: 25px;"
          >{{proviceText}} {{cityText}} {{areaText}}</div>
        </div>
        <div class="item phone">
          <div class="left">
            <span class="text">
              <span>*</span> 身份证号：
            </span>
          </div>
          <div class="input3" v-if="!auth">
            <p class="errorMsg">{{errorMsg.identityNumber}}</p>
            <input
              @input="changeIdcard(user.identityNumber)"
              @blur="checkInput('id')"
              type="text"
              v-model="user.identityNumber"
            >
            <i
              class="iconfont icon-close"
              v-if="user.identityNumber"
              @click="clear($event,'identityNumber')"
            ></i>
          </div>
          <div v-else class="input3">{{user.identityNumber || '暂无'}}</div>
        </div>
      </div>
      <div class="small-title" :class="isShowTop !== 1 ? 'small-persion-title': ''">
        <i></i>
        <span>作品案例</span>
      </div>
      <div>
        <div class="item phone" id="personal-item">
          <div class="left">
            <span class="text">
              <span>*</span>作品1：
            </span>
          </div>
          <div
            v-if="(!realNameAuth && !detailData) || (detailData && (detailData.status === 3 || !detailData.status))"
            class="input5"
            :class="isShowTop !== 1 ? 'small-input5': ''"
          >
            <div class="imgConBanner" :class="isShowTop !== 1 ? 'small-imgConBanner': ''">
              <div
                class="left"
                v-if="artisticWorks[0].detailImage.length <= 8"
                :class="isShowTop !== 1 ? 'small-left': ''"
              >
                拖动你的原创作品图到这里
                <span class="red">（至少上传1张）</span>
                <my-upload
                  :type="17"
                  style="height: 100%;"
                  :multiple="true"
                  :format="['jpg','jpeg','png']"
                  @success="handleSuccess3"
                  @uploadError="handleUploadError"
                  @formatError="handleFormatError"
                  @progress="handleProgress3"
                ></my-upload>
              </div>
              <div slot="style" class="show" :class="isShowTop !== 1 ? 'small-show': ''">
                <div
                  class="uploadImgItem"
                  :key="index"
                  v-if="progress01 > 0 || (artisticWorks[0].detailImage.length >= 0 && index < 10)"
                  v-for="(item,index) in artisticWorks[0].detailImage"
                >
                  <div class="imgCon" v-if="artisticWorks[0].detailImage">
                    <img v-if="item" :src="imgBaseUrl + item.key" alt>
                  </div>
                  <!--<Progress style="width: 188px;" :percent="artisticWorks[0].detailImage.length > 0 ? 100 : progress01" :stroke-width="6"></Progress>-->
                  <span @click="deleteUploadItem01(item)" class="iconfont icon-trash"></span>
                </div>
                <div class="uploadImgItem" v-if="isProgressShow01">
                  <div class="imgCon"></div>
                  <Progress style="width: 188px;" :percent="progress01" :stroke-width="6"></Progress>
                </div>
                <div class="bottomText" v-if="artisticWorks[0].detailImage.length > 0">
                  已经选择
                  <span>{{artisticWorks[0].detailImage.length}}</span>张，还可以选择
                  <span>{{9-parseInt(artisticWorks[0].detailImage.length)}}</span>张
                </div>
              </div>
            </div>
          </div>
          <div class="input5" :class="isShowTop !== 1 ? 'small-input5': ''" v-else>
            <div
              class="realNameAuth-img"
              :key="index"
              v-if="progress01 > 0 || (artisticWorks[0].detailImage.length >= 0 && index < 10)"
              v-for="(item,index) in artisticWorks[0].detailImage"
            >
              <div class="imgCon" v-if="artisticWorks[0].detailImage">
                <img v-if="item" :src="imgBaseUrl + item.key" alt>
              </div>
            </div>
          </div>

          <div class="left">
            <span class="text">
              <span>*</span>作品2：
            </span>
          </div>
          <div
            v-if="(!realNameAuth && !detailData) || (detailData && (detailData.status === 3 || !detailData.status))"
            class="input5"
            :class="isShowTop !== 1 ? 'small-input5': ''"
          >
            <div class="imgConBanner" :class="isShowTop !== 1 ? 'small-imgConBanner': ''">
              <div
                class="left"
                v-if="artisticWorks[1].detailImage.length <= 8"
                :class="isShowTop !== 1 ? 'small-left': ''"
              >
                拖动你的原创作品图到这里
                <span class="red">（至少上传1张）</span>
                <my-upload
                  :type="17"
                  style="height: 100%;"
                  :multiple="true"
                  :format="['jpg','jpeg','png']"
                  @success="handleSuccess5"
                  @uploadError="handleUploadError"
                  @formatError="handleFormatError"
                  @progress="handleProgress5"
                ></my-upload>
              </div>
              <div slot="style" class="show" :class="isShowTop !== 1 ? 'small-show': ''">
                <div
                  class="uploadImgItem"
                  :key="index"
                  v-if="progress02 > 0 || (artisticWorks[1].detailImage.length > 0 && index < 10)"
                  v-for="(item,index) in artisticWorks[1].detailImage"
                >
                  <div class="imgCon" v-if="artisticWorks[1].detailImage">
                    <img v-if="item" :src="imgBaseUrl + item.key" alt>
                  </div>
                  <span @click="deleteUploadItem02(item)" class="iconfont icon-trash"></span>
                </div>
                <div class="uploadImgItem" v-if="isProgressShow02">
                  <div class="imgCon"></div>
                  <Progress style="width: 188px;" :percent="progress01" :stroke-width="6"></Progress>
                </div>
                <div class="bottomText" v-if="artisticWorks[1].detailImage.length > 0">
                  已经选择
                  <span>{{artisticWorks[1].detailImage.length}}</span>张，还可以选择
                  <span>{{9-parseInt(artisticWorks[1].detailImage.length)}}</span>张
                </div>
              </div>
            </div>
          </div>
          <div class="input5" :class="isShowTop !== 1 ? 'small-input5': ''" v-else>
            <div
              class="realNameAuth-img"
              :key="index"
              v-if="progress02 > 0 || (artisticWorks[1].detailImage.length > 0 && index < 10)"
              v-for="(item,index) in artisticWorks[1].detailImage"
            >
              <div class="imgCon" v-if="artisticWorks[1].detailImage">
                <img v-if="item" :src="imgBaseUrl + item.key" alt>
              </div>
            </div>
          </div>
          <div class="left">
            <span class="text">
              <span>*</span>作品3：
            </span>
          </div>
          <div
            v-if="(!realNameAuth && !detailData) || (detailData && (detailData.status === 3 || !detailData.status))"
            class="input5"
            :class="isShowTop !== 1 ? 'small-input5': ''"
          >
            <div class="imgConBanner" :class="isShowTop !== 1 ? 'small-imgConBanner': ''">
              <div
                class="left"
                v-if="artisticWorks[2].detailImage.length <= 8"
                :class="isShowTop !== 1 ? 'small-left': ''"
              >
                拖动你的原创作品图到这里
                <span class="red">（至少上传1张）</span>
                <my-upload
                  :type="17"
                  style="height: 100%;"
                  :multiple="true"
                  :format="['jpg','jpeg','png']"
                  @success="handleSuccess7"
                  @uploadError="handleUploadError"
                  @formatError="handleFormatError"
                  @progress="handleProgress7"
                ></my-upload>
              </div>
              <div slot="style" class="show" :class="isShowTop !== 1 ? 'small-show': ''">
                <div
                  class="uploadImgItem"
                  :key="index"
                  v-if="progress03 > 0 || (artisticWorks[2].detailImage.length > 0 && index < 10)"
                  v-for="(item,index) in artisticWorks[2].detailImage"
                >
                  <div class="imgCon" v-if="artisticWorks[2].detailImage">
                    <img v-if="item" :src="imgBaseUrl + item.key" alt>
                  </div>
                  <!--<Progress style="width: 188px;" :percent="artisticWorks[2].detailImage.length > 0 ? 100 : progress03" :stroke-width="6"></Progress>-->
                  <span @click="deleteUploadItem03(item)" class="iconfont icon-trash"></span>
                </div>
                <div class="uploadImgItem" v-if="isProgressShow03">
                  <div class="imgCon"></div>
                  <Progress style="width: 188px;" :percent="progress01" :stroke-width="6"></Progress>
                </div>
                <div class="bottomText" v-if="artisticWorks[2].detailImage.length > 0">
                  已经选择
                  <span>{{artisticWorks[2].detailImage.length}}</span>张，还可以选择
                  <span>{{9-parseInt(artisticWorks[2].detailImage.length)}}</span>张
                </div>
              </div>
            </div>
          </div>
          <div class="input5" :class="isShowTop !== 1 ? 'small-input5': ''" v-else>
            <div
              class="realNameAuth-img"
              :key="index"
              v-if="progress03 > 0 || (artisticWorks[2].detailImage.length > 0 && index < 10)"
              v-for="(item,index) in artisticWorks[2].detailImage"
            >
              <div class="imgCon" v-if="artisticWorks[2].detailImage">
                <img v-if="item" :src="imgBaseUrl + item.key" alt>
              </div>
            </div>
          </div>
        </div>

        <div class="sure" @click="sureText" v-if="!realNameAuth || !auth">
          <span :class="suerTextData ? 'checkboxed' : 'check-box'"></span>
          <span class="text">我保证作品的原创性，上传的图片没有法律纠纷，我对因虚假资料或图片版权引起的法律纠纷负全部责任。</span>
        </div>
        <div class="sure" @click="sureText" v-if="realNameAuth && auth"></div>

        <div v-if="!detailData">
          <div class="button">
            <button :disabled="buttonBusy" @click="submitButton">立即提交</button>
          </div>
        </div>
        <div v-else>
          <div class="button" v-if="detailData && detailData.status === 1">
            <span class="specail">正在审核中...</span>
          </div>
          <div
            class="button"
            v-if="detailData && detailData.status === 2 && userInfo.certification > 0"
          ></div>
          <div
            class="button"
            v-if="detailData && detailData.status === 2 && userInfo.certification === 0"
          >
            <button :disabled="buttonBusy" @click="submitButton">确认修改</button>
          </div>
          <div class="button" v-if="(detailData && detailData.status === 3) || !detailData.status">
            <button :disabled="buttonBusy" @click="submitButton">确认修改</button>
          </div>
        </div>
      </div>

      <Modal v-model="imgValidator" class="imgValidator" width="360">
        <div class="close-btn" slot="close">
          <i class="iconfont icon-pop-close"></i>
        </div>
        <div slot="header" class="title">请输入验证码</div>
        <img-validate ref="imgValidator" :phone="user.phone" @sendMsg="sendMsgBegin"></img-validate>
      </Modal>
      <delete-confirm ref="deleteConfirm"></delete-confirm>
    </div>
  </div>
</template>
<script>
import api from "../../../api";
import myUpload from "../../common/myUpload.vue";
import util from "../../../libs/util";
import validator from "../account/validator";
import imgValidate from "../account/imgValidateModal.vue";
import loading from "../../common/loading.vue";
import deleteConfirm from "../../common/deleteConfirm.vue";
const reg_phone = validator.reg_phone;
import store from "../../../store";
export default {
  data() {
    return {
      user: {
        realName: "",
        phone: "",
        detailAddress: "",
        code: "",
        identityNumber: "",
        locationId: null,
        cityId: null
      },
      errorMsg: {
        realName: "",
        phone: "",
        code: "",
        detailAddress: "",
        identityNumber: ""
      },
      suerTextData: false,
      provinceId: "",
      addressData: [],
      cityData: [],
      areaData: [],
      cityId: null,
      imgBaseUrl: api.common.imgBaseUrl,
      upload: {
        certificateFile3: [],
        certificateFile5: null,
        certificateFile7: null
      },
      isUploadUse: {
        idCard: 0,
        works: 0
      },
      artisticWorks: [
        {
          detailImage: []
        },
        {
          detailImage: []
        },
        {
          detailImage: []
        }
      ],
      progress01: 0,
      progress02: 0,
      progress03: 0,
      proviceText: "",
      cityText: "",
      areaText: "",
      detailData: null,
      timer: 0,
      imgValidator: false,
      isProgressShow01: false,
      isProgressShow02: false,
      isProgressShow03: false,

      auth: false,
      realNameAuth: false,
      busy: false,
      buttonBusy: false
    };
  },
  props: {
    isShowTop: {
      type: Number,
      default: 1
    }
  },
  components: {
    myUpload,
    imgValidate,
    loading,
    deleteConfirm
  },
  computed: {
    userInfo() {
      return this.$store.state.user.info;
    }
  },
  methods: {
    changeIdcard(val) {
      const reg = /^[^\u4e00-\u9fa5]+$/;
      if (!reg.test(val)) {
        this.user.identityNumber = "";
      }
    },
    handleSuccess3(data) {
      this.artisticWorks[0].detailImage.push(data.data[0]);
      this.isProgressShow01 = false;
    },
    deleteUploadItem01(item) {
      this.artisticWorks[0].detailImage.splice(
        this.artisticWorks[0].detailImage.indexOf(item),
        1
      );
    },

    handleSuccess5(data) {
      this.artisticWorks[1].detailImage.push(data.data[0]);
      this.isProgressShow02 = false;
    },
    deleteUploadItem02(item) {
      this.artisticWorks[1].detailImage.splice(
        this.artisticWorks[1].detailImage.indexOf(item),
        1
      );
    },
    handleSuccess7(data) {
      this.artisticWorks[2].detailImage.push(data.data[0]);
      this.isProgressShow03 = false;
    },
    deleteUploadItem03(item) {
      this.artisticWorks[2].detailImage.splice(
        this.artisticWorks[2].detailImage.indexOf(item),
        1
      );
    },

    handleUploadError() {
      this.$Message.error("上传失败,请重新上传");
    },
    handleFormatError() {
      this.$Message.error("请选择 jpg,jpeg 或 png 格式的文件");
    },
    handleProgress3(progress) {
      if (progress) {
        this.isProgressShow01 = true;
        this.progress01 = parseInt(progress);
      }
    },
    handleProgress5(progress) {
      if (progress) {
        this.isProgressShow02 = true;
        this.progress02 = progress;
      }
    },

    handleProgress7(progress) {
      if (progress) {
        this.isProgressShow03 = true;
        this.progress03 = progress;
      }
    },

    closeImgValidator() {
      this.imgValidator = false;
    },
    sendMsgBegin() {
      this.closeImgValidator();
      let that = this;
      this.timer = parseInt(util.getCookie("authenticationCountDown")) || 90;
      that.timerInterval = setInterval(function() {
        that.timer--;
        util.setCookie("authenticationCountDown", that.timer);
        if (that.timer == 0) {
          util.setCookie("authenticationCountDown", "", -1);
          clearInterval(that.timerInterval);
        }
      }, 1000);
    },

    initLocation() {
      if (!this.user.locationId) {
        return;
      }
      this.addressData.forEach(province => {
        province.cities.forEach(city => {
          this.cityData = city.cities;
          this.cityId = city.id;
          this.cityData.forEach(cityCC => {
            if (cityCC.id === this.user.locationId) {
              this.provinceId = province.id;
              this.areaData = cityCC.cities;
              this.proviceText = province.name;
              this.cityText = city.name;
              this.areaText = cityCC.name;
            }
          });
        });
      });
    },
    getCode() {
      if (this.user.phone) {
        if (!reg_phone.test(this.user.phone)) {
          this.errorMsg.phone = "您输入的手机号不符合规则";
          return;
        } else {
          api.account
            .checkPhoneExist({
              phone: this.user.phone
            })
            .then(res => {
              if (res) {
                this.$refs.imgValidator.open("realName");
                this.imgValidator = true;
              }
            });
        }
      } else {
        this.errorMsg.phone = "手机号必填";
      }
    },

    checkInput(check) {
      this.validate(check, false);
    },

    changeProvince(pid) {
      this.errorMsg.detailAddress = "";
      this.addressData.forEach(province => {
        if (province.id == pid) {
          this.cityData = province.cities;
          this.proviceText = province.name;
          this.cityId = null;
          this.user.locationId = null;
        }
      });
    },
    changeCity(cid) {
      this.errorMsg.detailAddress = "";
      this.cityData.forEach(city => {
        if (city.id === cid) {
          this.cityText = city.name;
          this.areaData = city.cities;
          this.user.locationId = null;
        }
      });
    },
    changeArea(aid) {
      this.errorMsg.detailAddress = "";
      this.areaData.forEach(area => {
        if (area.id === aid) {
          this.areaText = area.name;
        }
      });
    },
    clear(e, key) {
      e.target.previousElementSibling.focus();
      this.user[key] = "";
    },
    sureText() {
      this.suerTextData = !this.suerTextData;
    },

    submitButton() {
      if (this.validate("nothing", true)) {
        if (this.suerTextData) {
          this.buttonBusy = true;
          let data = {
            artisticWorks: this.artisticWorks,
            identityNumber: this.user.identityNumber,
            locationId: this.user.locationId,
            phone: this.user.phone,
            code: this.user.code,
            realName: this.user.realName
          };
          api.account
            .verifyIndividual(data)
            .then(res => {
              if (res.realNameAuth) {
                this.$router.push({ name: "myApplicationing" });
              } else {
                this.$refs.deleteConfirm.open({
                  text: "实名认证失败，请修改认证信息！",
                  bigButton: true
                });
              }
              this.buttonBusy = false;
            })
            .catch(err => {
              this.$refs.deleteConfirm.open({
                text: err.data.message || "服务器出错！",
                bigButton: true
              });
              this.buttonBusy = false;
            });
        } else {
          this.$Message.error("请确定相关责任！");
        }
      }
    },

    getVerifyIndividual() {
      this.busy = true;
      api.account.getVerifyIndividual().then(res => {
        if (res) {
          this.auth = res.realNameAuth;
          this.realNameAuth = res.auth;
          if (this.auth) {
            this.$emit("isShowCheck", 0);
          }
          if (res.obj) {
            if (res.obj.realName) {
              this.detailData = res.obj;
              if (res.obj.artisticWorks) {
                this.artisticWorks = res.obj.artisticWorks;
              } else {
                this.artisticWorks = [
                  { detailImage: [] },
                  { detailImage: [] },
                  { detailImage: [] }
                ];
              }
              this.user.identityNumber = res.obj.identityNumber;
              this.user.locationId = res.obj.locationId;
              this.user.phone = res.obj.phone;
              this.user.code = res.obj.code;
              this.user.realName = res.obj.realName;
            }
          }
        }
        this.busy = false;
      });
    },

    checkInput(check) {
      this.validate(check, false);
    },

    validate(check, nomal) {
      if (check === "name" || nomal) {
        if (!this.user.realName) {
          this.errorMsg.realName = "请输入您的真实姓名";
          if (nomal) {
            this.$Message.error("请输入您的真实姓名");
          }
          return false;
        } else {
          this.errorMsg.realName = "";
        }
      }

      if (check === "phone" || nomal) {
        if (!this.user.phone) {
          this.errorMsg.phone = "请输入您的手机号码";
          if (nomal) {
            this.$Message.error("请输入您的手机号码");
          }
          return false;
        } else if (!reg_phone.test(this.user.phone)) {
          this.errorMsg.phone = "您的手机号码不合法";
          if (nomal) {
            this.$Message.error("您的手机号码不合法");
          }
          return false;
        } else {
          this.errorMsg.phone = "";
        }
      }

      if (!this.auth) {
        if (check === "code" || nomal) {
          if (!this.user.code) {
            this.errorMsg.code = "请输入验证码 ";
            if (nomal) {
              this.$Message.error("请输入验证码");
            }
            return false;
          } else {
            this.errorMsg.code = "";
          }
        }
      }

      if (!this.provinceId) {
        this.errorMsg.detailAddress = "请选择您的省份";
        if (nomal) {
          this.$Message.error("请选择您的省份");
          return false;
        }
      } else if (!this.user.locationId) {
        this.errorMsg.detailAddress = "请选择您所在城市或区/县城";
        if (nomal) {
          this.$Message.error("请选择您所在城市或区/县城");
          return false;
        }
      } else {
        this.errorMsg.detailAddress = "";
      }

      if (check === "id" || nomal) {
        if (!this.user.identityNumber) {
          this.errorMsg.identityNumber = "请输入您的身份证账号";
          if (nomal) {
            this.$Message.error("请输入您的身份证账号");
          }
          return false;
        } else if (!validator.checkCard(this.user.identityNumber)) {
          this.errorMsg.identityNumber = "您的身份证账号不合法";
          if (nomal) {
            this.$Message.error("您的身份证账号不合法");
          }
          return false;
        } else {
          this.errorMsg.identityNumber = "";
        }
      }

      if (nomal) {
        let artisticWorksData = this.artisticWorks;
        for (let i = 0; i < artisticWorksData.length; i++) {
          if (artisticWorksData[i].detailImage.length === 0) {
            this.$Message.error("请完善作品！");
            return false;
          }
        }
      }
      return true;
    }
  },
  created() {
    const address_name = "vuejs__ZHULOGIC_ADDRESS" || "ZHULOGIC_ADDRESS";
    let lists = JSON.parse(localStorage.getItem(address_name)).value;
    if (lists) {
      this.addressData = lists;
    } else {
      api.address.getData().then(res => {
        this.addressData = res;
        this.initLocation();
      });
    }

    this.getVerifyIndividual();
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.main {
  .personal {
    #personal-item {
      .ivu-upload-select {
        /*width: 782px;*/
        width: 100%;
        height: 129px;
      }
      .upload {
        position: absolute;
        left: 0px;
        top: 0px;
        /*width: 782px;*/
        width: 100%;
        height: 129px;
        .ivu-upload {
          height: 129px;
        }
      }
      .ivu-progress-inner {
        border: 1px solid #3dbd7d;
      }
      .ivu-progress-success .ivu-progress-text {
        > span {
          float: left;
          margin-top: 0px;
          height: 60px;
        }
      }
    }
    .item {
      .input5 {
        width: 875px;
        .left {
          display: block;
          width: 782px;
          height: 129px;
          line-height: 129px;
          color: #6c6f70;
          margin-bottom: 20px;
          .red {
            color: #e14b5d;
          }
        }
        .small-left {
          width: 700px;
        }
        .show {
          width: 779px;
          .uploadImgItem {
            width: 100%;
            height: 64px;
            line-height: 64px;
            background: #ebeff0;
            border-radius: 4px;
            margin-bottom: 10px;
            .imgCon {
              height: 64px;
              width: 64px;
              float: left;
              overflow: hidden;
              margin-right: 26px;
              border-top-left-radius: 4px;
              border-bottom-left-radius: 4px;
              > img {
                height: 100%;
                width: 100%;
                object-fit: cover;
              }
            }
            .iconfont {
              float: right;
              margin-right: 15px;
              color: #6c6f70;
              cursor: pointer;
            }
          }
          .small-uploadImgItem {
            width: 700px;
          }
          .bottomText {
            text-align: center;
            font-size: 12px;
            color: #6c6f70;
            margin-bottom: 20px;
            margin-top: 18px;
            > span {
              color: #e14b5d;
            }
          }
        }
        .small-show {
          width: 700px;
        }
        .realNameAuth-img {
          width: 96px;
          height: 96px;
          margin-right: 33px;
          overflow: hidden;
          margin-bottom: 33px;
          display: inline-block;
          .imgCon {
            height: 100%;
            width: 100%;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
      .small-input5 {
        width: 700px;
        .realNameAuth-img {
          width: 96px;
          height: 96px;
          margin-right: 33px;
          overflow: hidden;
          margin-bottom: 33px;
          .imgCon {
            height: 100%;
            width: 100%;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
  }
}
</style>
